import { render, staticRenderFns } from "./LinearBorderIcon.vue?vue&type=template&id=ff716700&"
import script from "./LinearBorderIcon.vue?vue&type=script&lang=js&"
export * from "./LinearBorderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports